import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable, Subject, Subscription, takeUntil } from 'rxjs';
import { AdminService } from 'src/app/services/admin.service';
import { LoaderService } from 'src/app/services/loader.service';
import { AppConstants } from 'src/app/shared/app.constants';

@Component({
  selector: 'ness-agency-cds-assign-approver-form',
  templateUrl: './agency-cds-assign-approver-form.component.html',
  styleUrls: ['./agency-cds-assign-approver-form.component.scss']
})
export class AgencyCdsAssignApproverFormComponent implements OnInit {
  @Input() agency: ServerModels.UpdateAgencyViewModel = null;
  @Input() optOutEvents: Observable<void>;
  @Output() onUpdate = new EventEmitter<ServerModels.CDSUserViewModel>();

  private _optOutSubscription: Subscription;

  private _unsubscribe$: Subject<void> = new Subject<void>();
  rows: number = AppConstants.defaultTableRows;
  cdsApprovers: ServerModels.CDSUserViewModel[] = [];
  users: ServerModels.CDSUserViewModel[] = [];
  cloneUserList: ServerModels.CDSUserViewModel[] = [];
  selectedUser: ServerModels.CDSUserViewModel = null;
  selectedApprover: ServerModels.CDSUserViewModel = null;
  isLinkedAgency: boolean = false;
  toggleIconClass: string = 'fas fa-minus-square';
  cols: any[] = [];  

  userListCols: any[] = [];

  constructor(
    public adminService: AdminService,
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    this._optOutSubscription = this.optOutEvents.subscribe(() => this.onOptOut());
    if (this.agency.OrganizationName) {
      this.isLinkedAgency = true;
    }
    this.setTableColumnValues();
    this._getUserLists();
  }

  ngOnDestroy() {
    this._optOutSubscription.unsubscribe();
  }

  private _getUserLists(): void {
    this.adminService.getUserByAgencyId(this.agency.AgencyID).pipe(takeUntil(this._unsubscribe$)).subscribe(
      (userList: ServerModels.CDSUserViewModel[]) => {

        if (userList) {
          this.CloneUser(userList);
          this.users = userList;

          let approver = userList.filter(x => x.UserRole?.includes("CDS Approver"));
          if (approver) {
            this.cdsApprovers = approver;

            approver.forEach(obj => {
              const index: number = this.users.indexOf(obj);
              if (index !== -1) {
                // Remove CDS approver from the user list
                this.users.splice(index, 1);
              }
             });
          }
        }
      });
  }

  private setTableColumnValues(): void {
    this.userListCols = [
      { header: 'LastName', field: 'LastName', visible: true },
      { header: 'FirstName', field: 'FirstName', visible: true },
      { header: 'Email', field: 'Email', visible: true },
      { header: 'Phone Number', field: 'PhoneNumber', visible: true },
      { header: 'Agency Name', field: 'AgencyName', visible: true },
      { header: 'Parent Agency Name', field: 'AgencyOrganizationName', visible: this.isLinkedAgency },
      { header: 'User Role', field: 'UserRole', visible: true },
      { header: 'Enabled/Disabled Status', field: 'UserAccountStatus', visible: true }
    ];

    this.cols = [
      { header: 'CDS Approver', field: 'FirstName', visible: true },
      { header: 'Date Assigned', field: 'DateCDSApproverAssigned', visible: true },
      { header: 'Email', field: 'Email', visible: true },
      { header: 'Phone Number', field: 'PhoneNumber', visible: true },
      { header: 'Agency', field: 'AgencyName', visible: !this.isLinkedAgency },
      { header: 'Parent Agency', field: 'AgencyOrganizationName', visible: this.isLinkedAgency }
    ];
  }

  public addCDSApprover(): void{
    // Assign CDS Approver
    this.cdsApprovers = [];
    this.cdsApprovers.push(this.selectedUser);

    // Refresh User List
    this.users = [];
    this.cloneUserList.forEach((data) => {
      if (data.ApplicationUserID != this.selectedUser.ApplicationUserID)
        this.users.push(data);
    });
    
    this.onUpdate.emit(this.selectedUser);
    this.selectedUser = null;
  }

  public onOptOut(): void {
    this.removeCDSApprover();
  }

  public removeCDSApprover(): void {
    // CDS Approver
    const selectedUser = this.cdsApprovers.length > 0 ? this.cdsApprovers[0] : null;
    this.cdsApprovers = [];

    if (!selectedUser) {
      return;
    }

    // Refresh User List
    this.users = [];
    this.cloneUserList.forEach((data) => {
        this.users.push(data);
    });

    this.onUpdate.emit(selectedUser);
    this.selectedUser = selectedUser;
  }

  public toggleClass(state: string): void {
    if (state === 'hide') {
      this.toggleIconClass = 'fas fa-plus-square';
    }
    if (state === 'show') {
      this.toggleIconClass = 'fas fa-minus-square';
    }
  }

  public CloneUser(cdsUsers: ServerModels.CDSUserViewModel[]) {
    cdsUsers.forEach((data) => {
      this.cloneUserList.push(data);
    });
  }
}
